import { Check, ArrowUpRight } from "lucide-react";

const packages = [
  {
    id: "6_session",
    name: "The Awakening",
    sessions: "6 Sessions",
    price: "$1,000",
    note: "A grounded beginning.",
    tagline:
      "For the woman ready to soften her self-talk and witness her patterns with kindness.",
    features: [
      "Six 1:1 coaching sessions with Tammy",
      "Personal affirmation practice",
      "Releasing limiting belief work",
      "Between-session integration prompts",
    ],
    accent: false,
  },
  {
    id: "10_session",
    name: "The Rise",
    sessions: "10 Sessions",
    price: "$1,650",
    note: "Most chosen.",
    tagline:
      "For deep, embodied transformation — when you're ready to reconnect with your inner power.",
    features: [
      "Ten 1:1 coaching sessions with Tammy",
      "Mind–body healing framework",
      "Affirmation & self-love practice",
      "Workshop priority access",
      "Ongoing voice / text support",
    ],
    accent: true,
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 lg:py-32 bg-cream-soft"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <p className="text-xs tracking-eyebrow uppercase text-sage mb-6">
            1:1 Coaching with Tammy
          </p>
          <h2
            data-testid="services-headline"
            className="font-serif-display text-forest text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            Quiet, private guidance —<br />
            <span className="italic">held in your own rhythm.</span>
          </h2>
          <p className="mt-6 text-forest-soft text-lg leading-relaxed max-w-2xl">
            Choose the container that feels right for this season. Every
            session is a soft, intentional space to make the unconscious
            conscious, and write a kinder story for the life ahead.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8 lg:gap-10">
          {packages.map((p) => (
            <article
              key={p.id}
              data-testid={`service-card-${p.id}`}
              className={`relative rounded-3xl p-10 lg:p-12 transition-all duration-500 aw-shadow hover:-translate-y-1 border ${
                p.accent
                  ? "bg-forest text-cream border-forest"
                  : "bg-white text-forest border-sage/30"
              }`}
            >
              {p.accent && (
                <span className="absolute -top-3 left-10 inline-flex items-center gap-2 rounded-full bg-[#D8B4A0] text-forest px-4 py-1.5 text-[10px] tracking-eyebrow uppercase">
                  {p.note}
                </span>
              )}

              <p
                className={`text-[11px] tracking-eyebrow uppercase ${
                  p.accent ? "text-cream/60" : "text-sage"
                }`}
              >
                {p.sessions}
              </p>
              <h3
                className={`mt-3 font-serif-display text-4xl lg:text-5xl leading-tight ${
                  p.accent ? "text-cream" : "text-forest"
                }`}
              >
                {p.name}
              </h3>
              <p
                className={`mt-3 text-base italic font-serif-display ${
                  p.accent ? "text-cream/80" : "text-forest-soft"
                }`}
              >
                {p.tagline}
              </p>

              <div
                className={`mt-8 h-px w-16 ${
                  p.accent ? "bg-[#D8B4A0]/50" : "bg-sage/40"
                }`}
              />

              <ul className="mt-8 space-y-4">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <span
                      className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
                        p.accent ? "bg-[#D8B4A0]/30" : "bg-[#EAECE8]"
                      }`}
                    >
                      <Check
                        size={12}
                        className={p.accent ? "text-[#D8B4A0]" : "text-sage"}
                        strokeWidth={2.5}
                      />
                    </span>
                    <span
                      className={p.accent ? "text-cream/85" : "text-forest-soft"}
                    >
                      {f}
                    </span>
                  </li>
                ))}
              </ul>

              <a
                href="#connect"
                data-testid={`service-cta-${p.id}`}
                className={`mt-10 inline-flex w-full items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm tracking-[0.18em] uppercase transition-all duration-500 ease-out hover:scale-[0.98] ${
                  p.accent
                    ? "bg-cream text-forest hover:bg-[#D8B4A0]"
                    : "bg-forest text-cream hover:bg-[#4A5D4E]"
                }`}
              >
                Book this Package
                <ArrowUpRight size={16} />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
